<template>
  <div>
    404
  </div>
</template>
<script>
export default {
  beforeCreate: function() {
    location.href = 'http://www.gabia.com/error_page/err_404.html/';
  }
};
</script>
